import React from 'react';
import { createRootRoute, Outlet, ScrollRestoration } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  );
}
